import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import {
  FulfillmentGroupData,
  FulfillmentGroupPickStatus,
} from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import DotIcon from "@redotech/redo-icons/dot-01.svg";
import {
  RedoBadge,
  RedoBadgeColor,
} from "@redotech/redo-web/arbiter-components/badge/redo-badge";
import { Flex } from "@redotech/redo-web/flex";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { memo } from "react";

const catalogEntry = fgColumnEntries.pickStatus;

const pickStatusBadgeText: Record<FulfillmentGroupPickStatus, string> = {
  [FulfillmentGroupPickStatus.PICKED]: "Picked",
  [FulfillmentGroupPickStatus.PROBLEM]: "Problem",
  [FulfillmentGroupPickStatus.IN_PROGRESS]: "In progress",
  [FulfillmentGroupPickStatus.HANDED_OFF]: "Handed off",
};

const pickStatusBadgeColor: Record<FulfillmentGroupPickStatus, RedoBadgeColor> =
  {
    [FulfillmentGroupPickStatus.PICKED]: "success",
    [FulfillmentGroupPickStatus.PROBLEM]: "error",
    [FulfillmentGroupPickStatus.IN_PROGRESS]: "warning",
    [FulfillmentGroupPickStatus.HANDED_OFF]: "blue",
  };

export const FulfillmentGroupPickStatusBadge = memo(
  function FulfillmentGroupPickStatusBadge({
    pickStatus,
    size = "xs",
  }: {
    pickStatus: FulfillmentGroupPickStatus | null | undefined;
    size?: "xs" | "sm";
  }) {
    if (!pickStatus || !(pickStatus in pickStatusBadgeText)) {
      return null;
    }

    return (
      <Flex flexDirection="column" justify="center">
        <RedoBadge
          color={pickStatusBadgeColor[pickStatus]}
          segmentLeading={{ type: "icon", Icon: DotIcon }}
          size={size}
          text={pickStatusBadgeText[pickStatus]}
          type="primary"
        />
      </Flex>
    );
  },
);

export const PickStatusColumn: Column2<FulfillmentGroupData> = {
  alignment: ColumnAlignment.LEFT,
  key: catalogEntry.key,
  title: catalogEntry.title,
  renderNormalCell: ({ row }) => (
    <Flex pl="lg">
      <FulfillmentGroupPickStatusBadge pickStatus={row.pickStatus} />
    </Flex>
  ),
  width: catalogEntry.defaultWidth,
};
